<div [innerHTML]="dynamicScopedStyles"></div>
<article class="flex-column col-xs-12 sp-0 tt-editor" [style.height]="ttHeight">
    <h4 class="tt-input__label">
        {{ label }}
        <span *ngIf="ttRequired === true" class="tt-input__label--required">*</span>
    </h4>
    <kendo-editor
        [style.flex]="ttHeight === 'auto' ? undefined : '1'"
        #editor
        [iframe]="false"
        [(value)]="ttModel"
        (valueChange)="onValueChange($event)"
        [readonly]="ttReadonly"
        (paste)="onPaste($event)"
        style="margin-bottom: 7px"
        [schema]="schema"
    >
        <kendo-toolbar class="k-toolbar-solid" [hidden]="ttReadonly" [overflow]="mobileQuery.matches === false">
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-colorpicker kendoEditorForeColor [views]="['gradient', 'palette']"></kendo-toolbar-colorpicker>
            <kendo-toolbar-colorpicker kendoEditorBackColor [views]="['gradient', 'palette']"></kendo-toolbar-colorpicker>

            <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                <kendo-toolbar-button title="Insert videolink" [svgIcon]="videoIcon" (click)="open()"></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-editor-insert-table-button></kendo-editor-insert-table-button>

            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
        </kendo-toolbar>
    </kendo-editor>
    <kendo-dialog *ngIf="insertVideoOpened" [top]="100" width="400px" title="Insert Video" (close)="close()">
        <kendo-label class="k-form" text="Embedded video URL">
            <input kendoTextBox [(ngModel)]="embeddedVideoUrl" />
        </kendo-label>

        <kendo-label class="k-form" text="Video source URL">
            <input kendoTextBox [(ngModel)]="videoUrl" />
        </kendo-label>

        <kendo-label class="k-form" text="Width (px)">
            <kendo-numerictextbox [(value)]="defaultWidth" [min]="100" [max]="1900" [autoCorrect]="true"> </kendo-numerictextbox>
        </kendo-label>

        <kendo-label class="k-form" text="Height (px)">
            <kendo-numerictextbox [(value)]="defaultHeight" [min]="100" [max]="1900" [autoCorrect]="true"> </kendo-numerictextbox>
        </kendo-label>

        <kendo-dialog-actions layout="start">
            <button kendoButton themeColor="primary" type="button" (click)="insertVideo()">Insert Video</button>
            <button kendoButton type="button" (click)="close()">Cancel</button>
        </kendo-dialog-actions>
    </kendo-dialog>
</article>
